import {
  ArchetypeResponseDto,
  CarrierType,
  CreateNonNumericOrderCommand,
  UpdateNonNumericOrderCommand,
} from '@planning/app/api'
import { NnrOrderItemStore } from '@planning/rt-stores/nnrOrder/NnrOrderItemStore'
import { nnrOrderService } from '@planning/services'
import { Dayjs } from 'dayjs'
import { computed, makeObservable } from 'mobx'
import { ReleaseControlViewStore } from './ReleaseControlViewStore'

export interface NnrOrderFormData {
  archetypeId: number | null
  referenceNumber: string
  shippingLine: string
  amount: number
  modeOfTransport: CarrierType
  transportCompanyId: number | null
  carrierVisitId: number | null
  containerLength?: number
  containerHeight?: number
  containerType?: string | null
  containerIsoCode: string | null
  validityDate?: Dayjs | null | undefined
}

export class NnrOrderControlViewStore extends ReleaseControlViewStore<NnrOrderFormData> {
  constructor(private nnrOrderStore: NnrOrderItemStore) {
    super()
    makeObservable(this, {
      selectedArchetype: computed,
      selectedNnrOrder: computed,
    })
  }

  get selectedArchetype() {
    const selectedNnrOrder = this.selectedNnrOrder?.data
    let arquetype: ArchetypeResponseDto | undefined

    if (selectedNnrOrder?.archetypeId) {
      arquetype = {
        id: selectedNnrOrder.archetypeId,
        name: selectedNnrOrder?.archetypeName ?? '',
        heights: selectedNnrOrder?.containerHeights ?? [],
        lengths: selectedNnrOrder?.containerLengths ?? [],
        types: selectedNnrOrder?.containerTypes ?? [],
      }
    }

    return arquetype
  }

  get selectedNnrOrder() {
    return this.id ? this.nnrOrderStore.elements[this.id] : undefined
  }

  onDelete = async (id: number) => {
    await nnrOrderService.delete(id)
  }

  onSubmit = async (data: NnrOrderFormData) => {
    // Temporary workaround: keep end-of-day instant as UTC timestamp and compare by full timestamp
    // across UI/API. This works when users operate in the same timezone as the port.
    // Future: if business switches to tenant/port-local calendar-day semantics, this flow must be
    // replaced with timezone-aware date-boundary conversion on both frontend and backend.
    if (this.isEditMode) {
      const cmd: UpdateNonNumericOrderCommand = {
        ...data,
        id: this.id!,
        validityDate: data.validityDate?.toISOString(),
      }

      if (cmd.modeOfTransport === CarrierType.Truck) {
        cmd.carrierVisitId = undefined
      }

      await nnrOrderService.put(cmd)
    } else {
      const cmd: CreateNonNumericOrderCommand = {
        ...data,
        validityDate: data.validityDate?.toISOString(),
      }

      await nnrOrderService.post(cmd)
    }
  }
}
